export default class CompareImage {
    constructor(element = null) {
        if (!element) return;
        this.element = element;
        const options = {

            // UI Theme Defaults
            controlColor: "#FFFFFF",
            controlShadow: false,
            addCircle: true,
            addCircleBlur: false,

            // Label Defaults
            showLabels: false,
            labelOptions: {
                before: 'Before',
                after: 'After',
                onHover: false
            },

            // Smoothing
            smoothing: false,
            smoothingAmount: 100,

            // Other options
            hoverStart: false,
            verticalMode: false,
            startingPoint: 50,
            fluidMode: true
        };

        this.viewer = new ImageCompare(this.element, options).mount();
    }
}
